// extracted by mini-css-extract-plugin
export default {"container":"qr-z","heading":"rr-z","text":"sr-z","info":"tr-z","link":"ur-z","fullMaxWidth":"vr-z"};